import {
  Box,
  Button,
  Flex,
  Image,
  SlideFade,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

type Props = {
  // children: React.ReactNode;
  assetUrl: string;
  title: string;
  onContinue: () => void;
  animIndex: number;
};

const ChoiceContainer = ({ assetUrl, title, onContinue, animIndex }: Props) => {
  const { t } = useTranslation();
  // HACK: This is a hack for the image of the SME
  const isSME = assetUrl.includes('SME');
  return (
    <SlideFade
      in
      offsetX="100px"
      offsetY="0px"
      style={{ width: '100%', maxWidth: '600px' }}
      transition={{ enter: { delay: 0.1 + 0.3 * animIndex } }}
    >
      <Flex
        width="100%"
        flexDir="column"
        overflow="hidden"
        borderRadius="10px"
        background="white"
        border="2px solid transparent"
        _hover={{
          border: '2px solid',
          borderColor: 'secondaryColor',
        }}
        boxShadow="0 0 10px 5px rgba(0, 0, 0, 0.05)"
        justifyContent="center"
        alignItems="center"
        cursor="pointer"
        onClick={onContinue}
        py={{ sm: 6, md: 7 }}
      >
        <VStack height="100%" w="full">
          <Text
            fontSize={{ base: '22px', md: '36px' }}
            color="primaryColor"
            fontWeight="bold"
            zIndex={1}
          >
            {title}
          </Text>
          <Flex
            flexDir="column"
            background="transparent"
            alignItems="center"
            justifyContent="center"
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              h="206"
              overflow="hidden"
              zIndex={0}
              transform={isSME ? 'scale(1.5) translateY(-10px)' : 'scale(1)'}
            >
              <Image src={assetUrl} alt="House" h="100%" />
            </Box>
          </Flex>
        </VStack>
        <Button
          variant="reno"
          maxWidth={{ base: '60%', md: '40%' }}
          flexGrow={1}
          size="lg"
          onClick={onContinue}
        >
          {t('common.continue')}
        </Button>
      </Flex>
    </SlideFade>
  );
};

export default ChoiceContainer;
